import script from "./CustomersPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomersPage.vue?vue&type=script&setup=true&lang=ts"

import "./CustomersPage.vue?vue&type=style&index=0&id=285f86c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-285f86c7"]])

export default __exports__